export default "__VITE_ASSET__f3fa25ad__"